"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const favoritesbrand01 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 70 61",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-favoritesbrand01` : '') + (description ? ` desc-favoritesbrand01` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-favoritesbrand01"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-favoritesbrand01"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.315 60.88 10.089 32.717a15.877 15.877 0 0 1-3.018-18.45c2.316-4.592 6.717-7.8 11.827-8.623a16.192 16.192 0 0 1 13.97 4.473l4.447 4.407 4.446-4.407a16.192 16.192 0 0 1 13.97-4.473c5.11.822 9.512 4.031 11.827 8.624a15.88 15.88 0 0 1-3.015 18.441L37.315 60.88Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.797 7.362A15.192 15.192 0 0 0 14.69 3.166c-4.796.772-8.923 3.783-11.093 8.087a14.877 14.877 0 0 0 2.83 17.29l.014.014 26.506 27.42 26.51-27.428.014-.015a14.88 14.88 0 0 0 2.827-17.281c-2.17-4.304-6.296-7.315-11.093-8.087a15.192 15.192 0 0 0-13.107 4.196l-4.446 4.407a1 1 0 0 1-1.408 0l-4.447-4.407Zm1.408-1.42a17.192 17.192 0 0 0-14.833-4.75c-5.425.872-10.1 4.28-12.56 9.16A16.877 16.877 0 0 0 5.01 29.955L32.229 58.11a1 1 0 0 0 1.438 0l27.22-28.164a16.88 16.88 0 0 0 3.197-19.593c-2.461-4.882-7.136-8.289-12.561-9.161a17.192 17.192 0 0 0-14.833 4.75L32.948 9.65l-3.743-3.71Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = favoritesbrand01;